import React from 'react';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { handleSidebarHover, handleSidebarHoverAway } from '../../../util/utility.functions';
import './style.css';

const VoItemIconActive = require('./VoItemIconActive.png');
const VoItemIconInactive = require('./VoItemIconInactive.png');

function PackagesIcon(props) {
  const { active, label } = props;
  const imgSrc = active ? VoItemIconActive : VoItemIconInactive;
  return (
    <Tooltip title={label}>
      <img
        src={imgSrc}
        alt=""
        height="20"
        width="20"
        onMouseOver={(event) => { handleSidebarHover(event, VoItemIconActive); }}
        onFocus={(event) => { handleSidebarHover(event, VoItemIconActive); }}
        onMouseLeave={(event) => { handleSidebarHoverAway(event, active, VoItemIconInactive); }}
      />
    </Tooltip>
  );
}

PackagesIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.bool.isRequired,
};

export default PackagesIcon;
